module.exports = __webpack_public_path__ + "static/media/2.d26ff9d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/carousel/2.png
// module id = 56
// module chunks = 0